import "./css/signupVerification.css"
import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react";

const SignupVerification = () => {
    const url = process.env.REACT_APP_SERVER_URL;
    const [closeErrorMessage, setCloseErrorMessage] = useState(true);
    const [errorMessage, setErrorMessage] = useState();

    const navigate = useNavigate();

    useEffect(() => {
        // 1. अगर टोकन नहीं है, तो सीधे साइनअप पेज पर भेज दें
        if (!localStorage.getItem("signtoken")) {
            navigate("/signup");
            return;
        }

        // 2. 🚨 SECURITY FIX: 15-Minute Session Timeout
        // अगर यूज़र पेज खुला भूल जाए, तो 15 मिनट बाद सब कुछ डिलीट हो जाएगा
        const securityTimer = setTimeout(() => {
            localStorage.clear();
            setErrorMessage("For security reasons, your verification session has timed out. If you have verified your email, please login manually.");
            setCloseErrorMessage(false);
            
            // 5 सेकंड बाद यूज़र को लॉगिन पेज पर भेज दें
            setTimeout(() => {
                navigate("/login");
            }, 5000);
        }, 15 * 60 * 1000); // 15 Minutes

        // Cleanup: अगर यूज़र खुद पेज बदल दे तो टाइमर रोक दें
        return () => clearTimeout(securityTimer);

    }, [navigate]);

    const getAuthData = () => ({
        // Note: 'key' and 'token' are no longer updated dynamically by the frontend for Resend
        key: localStorage.getItem("key"),
        mail: localStorage.getItem("mail"),
        name: localStorage.getItem("name"),
        signtoken: localStorage.getItem("signtoken"),
        status: localStorage.getItem("status"),
        token: localStorage.getItem("token"),
        user_id: localStorage.getItem("user_id"),
    });

    const Reload = async () => {
        try {
            const responce = await fetch(url + "/user/reload", {
                method: "POST",
                body: JSON.stringify(getAuthData()),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            
            const result = await responce.json();
            
            if (!responce.ok || result.status === false) {
                setErrorMessage(result.message || "Unable to reload account status.");
                setCloseErrorMessage(false);
                return;
            }
            
            // 3. Success: User verified successfully via phone/other tab
            if (result.status === true) {
                localStorage.clear(); // Clear all temp registration data
                
                // Set permanent login data
                localStorage.setItem("token", result.token);
                localStorage.setItem("user_id", result.user_id);
                localStorage.setItem("name", result.name);
                localStorage.setItem("email", result.email);
                localStorage.setItem("status", result.code);
                
                // Redirect to course/dashboard
                navigate("/course");
            }
        } catch (error) {
            console.error("Reload Error:", error);
            setErrorMessage("Server connection failed. Please try again.");
            setCloseErrorMessage(false);
        }
    };

    const Resend = async () => {
        try {
            const responce = await fetch(url + "/user/resend", {
                method: "POST",
                body: JSON.stringify(getAuthData()),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            
            const result = await responce.json();
            
            if (!responce.ok || result.status === false) {
                setErrorMessage(result.message || "Failed to resend verification email.");
                setCloseErrorMessage(false);
                return;
            }
            
            // 4. CRITICAL FIX: We no longer set 'key' and 'token' in LocalStorage from API response.
            // This prevents the Account Takeover vulnerability.
            if (result.status === true) {
                setErrorMessage(result.message);
                setCloseErrorMessage(false);
            }
        } catch (error) {
            console.error("Resend Error:", error);
            setErrorMessage("Server connection failed. Please try again.");
            setCloseErrorMessage(false);
        }
    };

    return (
        <div className="authPageWrapper">
            <div className="authMainContainer">
                <div className="authImageSection verifyImageBg"></div>

                <div className="authFormSection">
                    <div className="authFormHeader">
                        <h2>User Verification</h2>
                        <p>Please check your inbox to verify your account.</p>
                    </div>

                    <div className="verifyMessageContent">
                        <div className="verifyIconBox">
                            <i className="fa-regular fa-envelope-open"></i>
                        </div>
                        <p>A verification link has been sent to your registered email address.</p>
                        <p>Please open your email and click the verification link to verify your account.</p>
                        <p>If you didn’t receive the email, click <strong>Resend</strong> to get a new link.</p>
                        <p>After successful verification, click <strong>Reload</strong> to proceed to your courses.</p>
                    </div>

                    <div className="verifyActionButtons">
                        <button className="secondaryBtn" onClick={Resend}>Resend</button>
                        <button className="submitBtn" onClick={Reload}>Reload</button>
                    </div>
                </div>
            </div>

            {!closeErrorMessage && (
                <div className="authModalOverlay">
                    <div className="authModalBox">
                        <i className="fa-solid fa-circle-exclamation errorIcon"></i>
                        <p className="modalMessage">{errorMessage}</p>
                        <button className="modalBtn" onClick={() => setCloseErrorMessage(true)}>Ok</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SignupVerification;